var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { defaultProps as defaultDatePickerProps } from '../DatePicker/DatePicker';
const classNames = {
    container: 'ui input datepicker-input',
    overlayWrapper: 'overlay-wrapper',
    overlay: 'overlay',
};
const defaultInputProps = {
    className: 'ui input',
};
export const DatePickerInput = (props) => {
    const { dayPickerProps, inputProps } = props, rest = __rest(props, ["dayPickerProps", "inputProps"]);
    const mergedDayPickerProps = Object.assign(Object.assign({}, defaultDatePickerProps), dayPickerProps);
    const mergedInputProps = Object.assign(Object.assign({}, defaultInputProps), inputProps);
    return (React.createElement(DayPickerInput, Object.assign({ dayPickerProps: mergedDayPickerProps, inputProps: mergedInputProps, classNames: classNames }, rest)));
};
DatePickerInput.displayName = 'DatePickerInput';
export default DatePickerInput;
//# sourceMappingURL=DatePickerInput.js.map